'use strict';

var _ = require('lodash');
var React = require('react');

var SimplePostArticleModule = require('./simple-post-article.jsx');



var HeaderEspecialPublicitario = React.createClass({
    getInitialState: function() {
        var anunciante = this.props.pubeditorial.anunciante;
        anunciante.url = (anunciante.url || null);
        return null;
    },

    render: function() {
        var anunciante = this.props.pubeditorial.anunciante;
        return (
            <div className='feed-post-header post-header-special-advertising'>
                <span className='feed-post-header-chapeu gui-text-section-title gui-text-special-advertising'>
                    {decodeURI('Especial Publicit%C3%A1rio')}
                </span>
                <a href={anunciante.url}>
                    <span className='feed-post-header-special-advertising-logo'>
                        <img className='special-advertising-logo' src={anunciante.logo_pequeno}/>
                    </span>
                </a>
            </div>
        );
    }
});

var SimplePostArticle = SimplePostArticleModule.classDefinition;

var EspecialPublicitario = React.createClass(_.extend({}, SimplePostArticle, {
    getContentType: function () {
        return 'especial-publicitario';
    },

    renderHeader: function() {
        return <HeaderEspecialPublicitario pubeditorial={this.props.pubeditorial} />;
    },

    renderTitle: function() {
        return (
            <p className='feed-post-body-title gui-text-title gui-color-primary feed-post-advertising-title'>
                {this.props.content.title}
            </p>
        );
    }
}));

module.exports = EspecialPublicitario;
